module.exports = __webpack_public_path__ + "img/Divii-Logo-Primary-Colour.cfb6f6b4.png";